import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchOnboarding } from '../../store/onboarding/actions';

import * as Styles from './SearchStyles';
import Menu from '../../components/application/Menu';
import OnboardingComponent from '../../components/application/OnboardingComponent/OnboardingComponent';
import Icon from '../../components/ui/Icon';
import Banner from '../../components/ui/Banner';
import { AppState } from '../../store';

interface SearchProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

const Search: React.FC<SearchProps> = ({ value, onChange, onSubmit }) => {
  /*
    * Hooks
  */
  const hasBanner = useSelector((state: AppState) => state.banner.hasBanner);

  const dispatch = useDispatch();

  MdHub.event.add('core:moduleHide', (module) => {
    if (module.moduleName === 'platform.onboarding-modal') {
      dispatch(fetchOnboarding());
    }
  });

  return (
    <Styles.Container>
      <Menu />
      <Styles.Page>
        <Styles.Wrapper>
          <Styles.WrapperForm hasBanner={hasBanner}>
            <Styles.Form onSubmit={onSubmit} autoComplete="off">
              <Styles.Input
                placeholder="Digite o token da receita"
                name="token"
                onChange={onChange}
                value={value}
                autoFocus
              />
              <Styles.Button>
                <Icon name="arrow-right" />
              </Styles.Button>
            </Styles.Form>
          </Styles.WrapperForm>
          <Banner />
        </Styles.Wrapper>
        <OnboardingComponent />
      </Styles.Page>
    </Styles.Container>
  );
};

export default Search;
